import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';
import { Controle } from './controle.model';

export class ControleResultat {
    static jsonMap = {
        controles: { key: 'controleList', converter: new (ArrayClassConverterFactory.build(Controle))() }
    };

    controles: Controle[] = [];
}
